export const getUserLanguage = () => {
    const userLang = navigator.language || navigator.userLanguage;
    return userLang.startsWith('pt') ? 'pt' : 'en'; // Default to English if not Portuguese
  };